export default __webpack_public_path__ + "static/media/announcement_4.1e97ff64.png";